import React from "react";
import { ChakraProvider, extendTheme } from "@chakra-ui/react";
import {
  BrowserRouter as Router,
  Route,
  BrowserRouter,
  Routes,
} from "react-router-dom";

import AddUser from "./components/AddUser";

import "./App.css";
import { AuthProvider } from "./components/authContext";
import { PrivateRoute } from "./components/privateRoute";
import { LanguageProvider } from "./components/languageContext";
import LoginPage from "./components/loginPage";
import ImageUpload from "./components/ImageUpload";
import FloraUpload from "./components/FloraUpload";
import FaunaUpload from "./components/FaunaUpload";
import EditFaunaPage from "./components/EditFaunaPage";
import EditFloraPage from "./components/EditFloraPage";
import EditImagePage from "./components/EditImagePage";
import Dashboard1 from "./components/Dashboard1";
import Dashboard2 from "./components/Dashboard2";
// import EditFaunaPage from "./components/EditFaunaPage";

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <ChakraProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<LoginPage />} />

              <Route path="/edit/" element={<EditFloraPage />} />

              <Route path="/edit/fauna" element={<EditFaunaPage />} />
              <Route path="/edit/flora" element={<EditFloraPage />} />
              <Route path="/edit/image" element={<EditImagePage />} />

              <Route path="/flora" element={<PrivateRoute />}>
                <Route path="/flora" element={<FloraUpload />} />
              </Route>

              <Route path="/fauna" element={<PrivateRoute />}>
                <Route path="/fauna" element={<FaunaUpload />} />
              </Route>
              <Route path="/image" element={<PrivateRoute />}>
                <Route path="/image" element={<ImageUpload />} />
              </Route>
              <Route path="/AddUser" element={<PrivateRoute />}>
                <Route path="/AddUser" element={<AddUser />} />
              </Route>
              <Route path="/Dashboard1" element={<PrivateRoute />}>
                <Route path="/Dashboard1" element={<Dashboard1 />} />
              </Route>
              <Route path="/Dashboard2" element={<PrivateRoute />}>
                <Route path="/Dashboard2" element={<Dashboard2 />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </ChakraProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
